import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, contentChildren, input } from '@angular/core';

import { TranslationPath } from '../model/translation';
import { useI18n } from '../services/i18n.service';
import { I18nInterpolateDirective } from './i18n-interpolate.directive';

@Component({
  selector: 'i18n',
  imports: [NgTemplateOutlet],
  template: `
    @for (part of parts(); track part) {
      @if (isString(part)) {
        <!-- comment needed to absorb whitespace-->{{ part
        }}<!-- comment needed to absorb whitespace-->
      } @else {
        <ng-template [ngTemplateOutlet]="part" />
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class I18nComponent {
  readonly key = input.required<TranslationPath>();
  readonly values = input<object>({});

  protected readonly i18n = useI18n();
  protected readonly children = contentChildren(I18nInterpolateDirective);

  protected isString(value: unknown): value is string {
    return typeof value === 'string';
  }

  protected readonly parts = computed(() =>
    this.i18n(this.key(), {
      ...this.values(),
      ...Object.fromEntries(
        this.children().map((interpolate) => [interpolate.slot(), interpolate.templateRef as never]),
      ),
    }),
  );
}
